import React from 'react';
import ToolButton from '../atoms/ToolButton';
import LeftIcon from '../atoms/LeftIcon';
import UpIcon from '../atoms/UpIcon';
import IncreaseIcon from '../atoms/IncreaseIcon';
import RotateRightIcon from '../atoms/RotateRightIcon';
import FrontIcon from '../atoms/FrontIcon';
import RightIcon from '../atoms/RightIcon';
import DownIcon from '../atoms/DownIcon';
import DecreaseIcon from '../atoms/DecreaseIcon';
import RotateLeftIcon from '../atoms/RotateLeftIcon';
import BackIcon from '../atoms/BackIcon';
const ToolsContainer = React.memo(({ strings, extraClass, disabled, handleToolClick, handleLayerChange }) => {
    return (React.createElement("div", { className: `th-c-tools ${extraClass}` },
        React.createElement(ToolButton, { label: strings.front_btn, onClickEvent: () => handleLayerChange('front'), disabled: disabled },
            React.createElement(FrontIcon, null)),
        React.createElement(ToolButton, { label: strings.back_btn, onClickEvent: () => handleLayerChange('back'), disabled: disabled },
            React.createElement(BackIcon, null)),
        React.createElement(ToolButton, { label: strings.left_btn, onClickEvent: () => handleToolClick('move-left'), disabled: disabled },
            React.createElement(LeftIcon, null)),
        React.createElement(ToolButton, { label: strings.up_btn, onClickEvent: () => handleToolClick('move-up'), disabled: disabled },
            React.createElement(UpIcon, null)),
        React.createElement(ToolButton, { label: strings.increase_btn, onClickEvent: () => handleToolClick('increase'), disabled: disabled },
            React.createElement(IncreaseIcon, null)),
        React.createElement(ToolButton, { label: strings.rotate_right_btn, onClickEvent: () => handleToolClick('rotate-right'), disabled: disabled },
            React.createElement(RotateRightIcon, null)),
        React.createElement(ToolButton, { label: strings.right_btn, onClickEvent: () => handleToolClick('move-right'), disabled: disabled },
            React.createElement(RightIcon, null)),
        React.createElement(ToolButton, { label: strings.down_btn, onClickEvent: () => handleToolClick('move-down'), disabled: disabled },
            React.createElement(DownIcon, null)),
        React.createElement(ToolButton, { label: strings.descrease_btn, onClickEvent: () => handleToolClick('decrease'), disabled: disabled },
            React.createElement(DecreaseIcon, null)),
        React.createElement(ToolButton, { label: strings.rotate_left_btn, onClickEvent: () => handleToolClick('rotate-left'), disabled: disabled },
            React.createElement(RotateLeftIcon, null))));
});
export default ToolsContainer;
